module.exports = __webpack_public_path__ + "img/news13_2.722bedf6.jpg";